<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <button (click)="createBoxCertificate()" color="primary" mat-button>
        New box ertificate
      </button>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortBoxCertificates($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2"
      mat-table matSort multiTemplateDataRows>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{element.id}} </td>
      </ng-container>

      <!-- Creation Date Column -->
      <ng-container matColumnDef="creationDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Creation Date</th>
        <td *matCellDef="let element" mat-cell> {{element.creationDate | date:"dd/MM/yyyy"}} </td>
      </ng-container>

      <!-- End Date Column -->
      <ng-container matColumnDef="endDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
        <td *matCellDef="let element" mat-cell> {{element.endDate | date:"dd/MM/yyyy"}} </td>
      </ng-container>

      <!-- Revoke Date Column -->
      <ng-container matColumnDef="revokeDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Revoke Date</th>
        <td *matCellDef="let element" mat-cell> {{element.revokeDate | date:"dd/MM/yyyy"}} </td>
      </ng-container>

      <!-- Box Column -->
      <ng-container matColumnDef="box">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Box</th>
        <td *matCellDef="let element" mat-cell> {{element.box?.identifier}} </td>
      </ng-container>

      <!-- CmId Column -->
      <ng-container matColumnDef="cmId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>CmId</th>
        <td *matCellDef="let element" mat-cell> {{element.cmId}} </td>
      </ng-container>

      <!-- status Column -->
      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
        <td *matCellDef="let element" mat-cell> {{element.status}} </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell class="text-right">
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">
            <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
              <mat-icon>visibility</mat-icon>
            </button>
            <ng-container
              *ngIf="element.status !== certificatesStatuses.expired && element.status !== certificatesStatuses.revoked">
              <button (click)="revokeBoxCertificate(element)" *awIsInAnyRole="[roles.admin]" [disabled]="disabled"
                [matTooltipPosition]="'after'" mat-icon-button matTooltip="Revoke box certificate">
                <mat-icon>block</mat-icon>
              </button>
            </ng-container>
            <ng-container
              *ngIf="!element.box || element.box.status == boxStatuses.assigned || element.box.status == boxStatuses.onTheShelf || element.box.status == boxStatuses.broken || element.box.status == boxStatuses.toBeConfigured">
              <button (click)="deleteBoxCertificate(element)" *awIsInAnyRole="[roles.admin]" [disabled]="disabled"
                [matTooltipPosition]="'after'" mat-icon-button matTooltip="Delete box certificate">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>

          </ng-container>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>
      <!--      <tr *matRowDef="let row; columns: ['expandedDetail']"-->
      <!--          [fxShow]="expandedContractEventsHistory?.id === row.id" mat-row></tr>-->


      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No certificates found
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorBoxCertificates [fxShow]="dataSource && dataSource.data.length > 10"
    [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>